import { fg } from '@atlassian/jira-feature-gating';

export const isOverridingFragments = (): boolean => {
	if (fg('is_overriding_fragments_analytics_prop')) {
		const re = /^(JF-TEST|MRJF-BB(\d+)?-\d+)$/;
		const buildKey = typeof window !== 'undefined' ? window?.BUILD_KEY : globalThis?.BUILD_KEY;
		return buildKey ? re.test(buildKey) : false;
	}

	if (typeof window !== 'undefined') {
		return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
	}

	if (typeof globalThis !== 'undefined') {
		return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
	}

	return false;
};
